import { ProductBlockIncludesLensesLink } from "../../../components/ProductBlockIncludesLensesLink/ProductBlock/components/ProductBlockFooter/components/ProductBlockIncludesLensesLink/ProductBlockIncludesLensesLink.js";
import { ProductBlockFooter as ProductBlockFooter$1 } from "./ProductBlockFooter.js";
import { VariantSwitcher } from "../../../../../../VariantSwitcher/VariantSwitcher/VariantSwitcher.js";
const ProductBlockFooter = Object.assign(ProductBlockFooter$1, {
  Variants: VariantSwitcher,
  IncludesLensesLink: ProductBlockIncludesLensesLink
});
export {
  ProductBlockFooter
};
//# sourceMappingURL=index.js.map
